import {cn} from "@adleritech/web-ui/utils";
import {forwardRef, type ReactNode} from "react";
import styles from "./FloatingSheet.module.css";

type FloatingSheetProps = {
    className?: string;
    children?: ReactNode;
};

export const FloatingSheet = forwardRef<HTMLDivElement, FloatingSheetProps>(function FloatingSheet(
    {className, children},
    ref
) {
    return (
        <div className={cn(styles.floatingSheet, className)} ref={ref}>
            {children}
        </div>
    );
});
